module.exports = __webpack_public_path__ + "images/180_640.jpg";